import React from 'react'
import SubNavbar from './SubNavbar';
import Navbar from './Navbar';

const MainNav = () => {
  return (
    <div>
      <Navbar />
      <SubNavbar />
    </div>
  )
}

export default MainNav
